<template>
  <div class="text-xs-center d-flex justify-center">
    <v-dialog v-model="dialog" width="50vh" overlay-color="white">
      <!-- button to open popUp to Add Link-->
      <template v-slot:activator="{ on }">
        <v-btn
          v-on="on"
          color="purple darken-4"
          icon
          @click="eventAnalytics;forceRerender()"
          style="outline: none;"
        >
          <v-icon>{{ icons.mdiPencil }}</v-icon>
        </v-btn>
      </template>

      <v-card color="white">
        <!-- PopUp Title -->
        <v-system-bar color="purple darken-4" height="30px">
          <v-spacer></v-spacer>
          <v-icon @click="dialog=false;" color="white" size="25">mdi-close</v-icon>
        </v-system-bar>

        <EditLinkInput
          ref="editLinkInput"
          :card="card"
          :key="componentKey"
          class="my-auto"
          @edit-link="$emit('edit-link', $event)"
          @close-pop-up="dialog=$event;component=0"
        />

        <v-divider style="margin-top:30px; margin-bottom: 0px;" />
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mdiPencil,mdiClose } from "@mdi/js";
import { analytics } from "@/config/firebaseConfig";
import EditLinkInput from "./EditLinkInput";

export default {
  components: { EditLinkInput },
  props: ["card","index"],
  data() {
    return {
      icons: {
        mdiPencil,
        mdiClose,
      },
      dialog: false,
      input: false,
      component: 0,
      componentKey: 1
    };
  },
  methods: {
    eventAnalytics() {
      analytics.logEvent("Btn_edtlink");
    },
    forceRerender(){
      this.componentKey +=1 ;
    }
  },
};
</script>

<style>
</style>